module.exports = __webpack_public_path__ + "static/media/nn.3a201a6a.png";